import { render } from "./StatisticsTabComponent.vue?vue&type=template&id=6489ea1c"
import script from "./StatisticsTabComponent.vue?vue&type=script&lang=js"
export * from "./StatisticsTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__